module.exports = __webpack_public_path__ + "static/media/uldaCentenario.36480bcd.jpg";